"use client"

// Error components must be Client Components
import IssueLayout from "@/components/layouts/issue"
import * as Sentry from "@sentry/nextjs"
// import { useLogger } from "next-axiom"
import { useEffect } from "react"

import { Button } from "@/components/ui/button"

import { Topbar } from "../components/nav/topbar"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  // const log = useLogger({ source: "error.tsx" })
  const log = Sentry.logger
  useEffect(() => {
    // Log the error to an error reporting service
    log.error("Error processing request", { error })
    Sentry.captureException(error)
    console.error(error)
    // }, [error])
  }, [error, log])

  return (
    <div className="">
      <Topbar />
      <div className="mx-auto max-w-7xl flex-1 gap-12 pb-12 pl-page-left pr-page-right">
        <IssueLayout.Viewport className="mt-12">
          <IssueLayout.Title>Something went wrong 😭</IssueLayout.Title>
          <p className="text-base/6">
            Sorry, something went wrong while trying to process your request.
          </p>
          <div className="mt-6 flex items-center gap-x-6">
            <Button
              onClick={
                // Attempt to recover by trying to re-render the segment
                () => reset()
              }
            >
              Try again
            </Button>
            <a
              href="mailto:support@fluentgroup.com.au"
              className="text-blue-11 transition-[colors,text-decoration-line,text-underline-offset] hover:underline hover:underline-offset-4 active:underline-offset-[6px]"
            >
              Contact support <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </IssueLayout.Viewport>
      </div>
    </div>
  )
}
